// removed by extract-text-webpack-plugin
module.exports = {"gray500":"#adb5bd","CallToAction":"CallToAction__CallToAction--2kFj9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CallToAction/CallToAction.scss
// module id = 401
// module chunks = 0